var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-block text-primary"},[_c('div',[_vm._t("default")],2),_c('div',{staticClass:"text-dark"},[_vm._v(" "+_vm._s(_vm.count)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }